import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-color",
  "use": "icon-color-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-color\">\n<path d=\"M1.25232 9.8655L2.67017 7.07049M2.67017 7.07049L3.37908 5.67298L5.50583 1.48047L7.63259 5.67298L8.3415 7.07049M2.67017 7.07049H8.3415M9.75935 9.8655L8.3415 7.07049\" stroke=\"#464646\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol